import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=16e0eba8&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=16e0eba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0eba8",
  null
  
)

export default component.exports